import { GetServerSidePropsContext } from "next";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";

import rehydrateApolloState from "../utils/rehydrateApolloState";
import createNewApolloClient from "./createNewApolloClient";

/** Get existing ApolloClient singleton or create a new instance if it doesn't exist
 * ---
 * We want to use the singleton instance of ApolloClient whenever we can so that we can
 * share a cache and keep things speedy.
 */

// Apollo singleton used for client session
let apolloClientSingleton: ApolloClient<NormalizedCacheObject> | null = null;

function getOrCreateApolloClient(
  initialState: NormalizedCacheObject | null = null,
  context?: GetServerSidePropsContext
) {
  // If apolloClient has already been created, use that here
  const apolloClient = apolloClientSingleton ?? createNewApolloClient(context);

  // Rehydrate Apollo cache from SSR environment
  if (initialState) {
    rehydrateApolloState(apolloClient, initialState);
  }

  // Reuse client - only on the client-side
  // This ensures that we do not share a cache between connections (which would be bad)
  if (!apolloClientSingleton && typeof window !== "undefined") {
    apolloClientSingleton = apolloClient;
  }

  return apolloClient;
}

export default getOrCreateApolloClient;
